import { render, staticRenderFns } from "./UserNotificationModal.vue?vue&type=template&id=21e27e17&scoped=true"
import script from "./UserNotificationModal.vue?vue&type=script&lang=js"
export * from "./UserNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./UserNotificationModal.vue?vue&type=style&index=0&id=21e27e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e27e17",
  null
  
)

export default component.exports